import Modal from "react-responsive-modal";

export const FilterModal = ({ open, onClose, children }) => {
  return (
    <>
      <style>{`
        .react-responsive-modal-modal {
          position: fixed !important;
          top: 50% !important;
          left: 50% !important;
          transform: translate(-50%, -50%) !important;
          margin: 0 !important;
        }
      `}</style>
      <Modal
        open={open}
        center
        onClose={onClose}
        classNames={{
          modal:
            "rounded-[8px] border-[1px] border-[#E3E3E3] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] w-[95vw] sm:w-[90vw] md:w-[500px] max-w-[500px] min-w-[280px]",
          overlay: "z-[99999999]",
          modalContainer: "z-[99999999]",
        }}
        styles={{
          modal: {
            zIndex: 99999999,
          },
          overlay: {
            zIndex: 99999999,
          },
          modalContainer: {
            zIndex: 99999999,
          },
        }}
      >
        <div className="w-full">
          {children}
        </div>
      </Modal>
    </>
  );
};
